module.exports = __webpack_public_path__ + "img/MapPicsMountainCrossing.72d340ec.webp";